<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5" id="grad1">
                <!-- breadcrumb and title row starts -->
                <div class="row">
                    <div class="col-sm-12 print-scr">
                        <vs-breadcrumb align="left" :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/program-officer/todoList'
                  },

                  {
                    title: 'Event Wizard',

                  },
                  {
                    title: ` ${trainingData.title} ${formatDateRange(trainingData.startdate, trainingData.enddate)}`,
                    active: true,
                    class: 'font-bold'
                  }
                ]"></vs-breadcrumb>
                    </div>
                    <div class="col-sm-12">
                        <div class="heading mt-3">
                            <h3 class="text-secondary">Event Wizard</h3>
                        </div>
                    </div>
                </div>
                <!-- breadcrumb and title row Ends -->
                <div class="row justify-content-center mt-0">
                    <div class="col-11 text-center p-0 mt-3 mb-2">
                        <div class="card px-0 pb-0 mt-3 mb-1">
                            <div class="row">
                                <div class="col-md-12 mx-0">
                                    <form id="msform">
                                        <!-- progressbar -->
                                        <ul id="progressbar">
                                            <li title="Warning! You are not authorized to access." id="NewTraining">
                                                <strong>Event Assignment</strong>
                                            </li>
                                            <li title="Warning! You are not authorized to access." id="PoAssignment">
                                                <strong>P.O Assignment</strong>
                                            </li>
                                            <li @click="trainingInformation()" class="completed" id="TrainingInformation">
                                                <strong>Event Information</strong>
                                            </li>
                                            <li @click="trainerRegistration()" class="completed" id="TrainerRegistration">
                                                <strong>Facilitators' Registration</strong>
                                            </li>
                                            <li @click="trainingAgenda()" class="completed" id="TrainingAgenda">
                                                <strong>Event Agenda</strong>
                                            </li>
                                            <li @click="trainingMaterial()" class="completed" id="Trainingmaterial">
                                                <strong>Upload Material</strong>
                                            </li>
                                            <li @click="trainingAssessment()" class="completed" id="TrainingAssessments">
                                                <strong>Assessments</strong>
                                            </li>

                                            <li @click="traineeReg()" class="completed" id="TraineeRegistration">
                                                <strong>Participants' Registration</strong>
                                            </li>
                                            <li @click="assessmentReviewFunction()" class="completed" id="AssessmentReview">
                                                <strong>Review</strong>
                                            </li>
                                            <li class="active" id="Completion">
                                                <strong>Completion</strong>
                                            </li>
                                        </ul>
                                        <!-- fieldsets -->
                                        <fieldset style="text-align: left;padding: 30px; min-height: 300px">
                                            <span v-if="this.trainingType != 1">
                                                <h5 class="text-center text-success mt-5">
                                                    <i class="material-icons">check</i> This Event
                                                    has been setup successfully!
                                                </h5>
                                            </span>
                                            <span v-else-if="this.training_status.preassesment_status == 1 && this.training_status.postassesment_status == 1">
                                                <h5 class="text-center text-success mt-5">
                                                    <i class="material-icons">check</i> This Event
                                                    has been setup successfully!
                                                </h5>
                                            </span>
                                            <span class="mt-3" v-else>
                                                <h5 class="text-center text-danger">
                                                    This Event is not completed and still
                                                    In-Progress
                                                </h5>
                                                <hr />
                                                <li class="text-success" v-if="this.training_status.preassesment_status == 1">
                                                    <i class="material-icons">check</i> Pre Assessment
                                                    is enabled and being completed.
                                                </li>
                                                <li v-else class="text-danger">
                                                    <i class="material-icons">close</i> Pre Assessment
                                                    is not enabled yet.
                                                </li>
                                                <li class="text-success" v-if="this.training_status.postassesment_status == 1">
                                                    <i class="material-icons">check</i> Post Assessment
                                                    is enabled and being completed.
                                                </li>
                                                <li v-else class="text-danger">
                                                    <i class="material-icons">close</i> Post Assessment
                                                    is not enabled yet.
                                                </li>
                                                <li class="text-success" v-if="this.training_status.feedbackstatus == 1">
                                                    <i class="material-icons">check</i> Feedback is
                                                    enabled and being completed.
                                                </li>
                                                <li v-else class="text-danger">
                                                    <i class="material-icons">close</i> Feedback is not
                                                    enabled yet.
                                                </li>
                                                <hr />
                                            </span>

                                            <!-- row 1 starts  -->
                                            <div class="row mt-3 mb-4 d-flex justify-content-center">
                                                <button class="btn btn-primary float-right ml-3">
                                                    <router-link :to="{
                              path:
                                '/dashboard/programOfficer/brief_training_report',
                              query: { trainingId: this.trainingCode }
                            }" class="white-text">Brief Event Details
                                                    </router-link>
                                                </button>

                                                <button class="btn btn-primary float-right ml-3">
                                                    <router-link :to="{
                                path:
                                  '/dashboard/programOfficer/analysis-report',
                                query: { trainingId: this.trainingCode }
                              }" class="white-text">Overall Event Analysis</router-link>
                                                </button>

                                                <button class="btn btn-primary float-right ml-3">
                                                    <router-link :to="{
                                path:
                                  '/dashboard/programOfficer/individual_analysis_report',
                                query: { trainingId: this.trainingCode }
                              }" class="white-text">Individual Event Analysis</router-link>
                                                </button>
                                                <button class=" btn btn-primary float-right ml-3" @click="getReport">
                                                    Download Event Report
                                                </button>
                                            </div>
                                            <!-- row 1 ends -->
                                            <!-- Review and Edit -->
                                            <div class="row d-flex justify-content-center">
                                                <button class="btn btn-info" @click="downloadReferences">
                                                    Download References
                                                    <i class="material-icons" style="font-size: 20px;">print</i>
                                                </button>
                                                <button class="btn btn-info float-right ml-5" @click="downloadSheet">
                                                    Attendance Sheet
                                                    <i class="material-icons" style="font-size: 20px;">file_download</i>
                                                </button>
                                                <button class="btn btn-info float-right ml-5" @click="printSheet">
                                                    Attendance Sheet
                                                    <i class="material-icons" style="font-size: 20px;">print</i>
                                                </button>

                                                <button class="btn btn-info ml-5">
                                                    <router-link :to="{ path:'/dashboard/programOfficer/addCertificate',query: { trainingId: this.trainingCode }}" class="white-text">Check Certificate
                                                        <i class="material-icons" style="font-size: 20px;">badge</i></router-link>
                                                </button>
                                            </div>
                                            <div class="row d-flex justify-content-center mt-4">

                                                <button class="btn btn-primary float-right ml-3">
                                                    <router-link :to="{
                                                           path:'/dashboard/programOfficer/feedbackTrainer',
                                                           query: { trainingId: this.trainingCode }
                                                               }" class="white-text">Facilitators Feedback
                                                    </router-link>
                                                </button>
                                                <button class="btn btn-primary float-right ml-3" @click="openNominationModal" v-if="this.nominationFiles.length > 0">
                                                    Nomination Letter
                                                    <span v-if="nominationFiles.length > 0" class="badge badge-light ml-1 mr-1 ">{{ nominationFiles.length }}</span>
                                                    <i class="material-icons" style="font-size: 20px;">visibility</i>
                                                </button>

                                            </div>
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <template>
                    <div>
                        <div id="attendance-sheet">
                            <div>
                                <img :src="Logo" alt="UNODC Logo" style="width: 200px;" />
                            </div>
                            <div>
                                <p class="address">
                                    G-5, Islamabad, Phone: (051) 2601461 <br />UNODC COAPK, Plot#
                                    5, Diplomatic Enclave
                                </p>
                            </div>

                            <div class="header">
                                <h3>Event Attendance Sheet</h3>
                            </div>

                            <table>
                                <tr>
                                    <th colspan="4" style="text-align: left;">
                                        Event Title:
                                        {{attendanceData.trainingResponse.title}}
                                    </th>
                                    <th colspan="3" style="text-align: left;">
                                        Event Dates:
                                        {{formattedDate(attendanceData.trainingResponse.startdate)}}
                                        <template v-if="attendanceData.trainingResponse.startdate !== attendanceData.trainingResponse.enddate">
                                            to {{formattedDate(attendanceData.trainingResponse.enddate)}}
                                        </template>
                                    </th>
                                </tr>
                                <tr>
                                    <th colspan="4" style="text-align: left;">
                                        Event Venue: {{attendanceData.trainingResponse.venue}}
                                    </th>
                                    <th colspan="3" style="text-align: left;">
                                        Total No. of Participants: (___________)
                                    </th>
                                </tr>
                            </table>
                            <br />
                            <table>
                                <tr>
                                    <th colspan="5" class="list_name">Participants</th>
                                    <th :colspan="attendanceData.trainingResponse.noofdays">
                                        Signature
                                    </th>
                                </tr>
                                <tr>
                                    <th>S#</th>
                                    <th>Name</th>
                                    <th>Organization</th>
                                    <th>Designation</th>
                                    <th>Mobile No</th>
                                    <!-- <th>Email</th> -->
                                    <th v-for="day in Number(attendanceData.trainingResponse.noofdays)" :key="'day-' + day">
                                        Day-{{ day }}
                                    </th>
                                </tr>
                                <tr v-for="(user, index) in attendanceData.traineeResponse" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        {{
                                           user.gender === 'male' ? 'Mr.' :
                                           user.gender === 'female' ? 'Ms.' :
                                           user.gender === 'rather not say' ? 'Mx' :
                                           ''
                                         }}
                                        {{ user.name || ' '}}</td>
                                    <td>{{ user.department || ' '}}</td>
                                    <td>{{user.designation || ' '}}</td>
                                    <td>{{user.contactNo }}</td>
                                    <!-- <td>{{user.email || ' '}}</td> -->
                                    <td v-for="day in Number(attendanceData.trainingResponse.noofdays)" :key="'user-day-' + index + '-' + day"></td>
                                </tr>
                                <tr v-for="emptyIndex in 10" :key="'empty-' + emptyIndex">
                                    <td>
                                        {{ attendanceData.traineeResponse.length + emptyIndex }}
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-for="day in Number(attendanceData.trainingResponse.noofdays)" :key="'user-day-' + index + '-' + day"></td>
                                </tr>
                            </table>
                            <br />
                            <table>
                                <tr>
                                    <th colspan="5" class="list_name">UNODC Staff</th>
                                    <th :colspan="attendanceData.trainingResponse.noofdays">
                                        Signature
                                    </th>
                                </tr>
                                <tr>
                                    <th>S#</th>
                                    <th>Name</th>
                                    <th>Department</th>
                                    <th>Designation</th>
                                    <th>Mobile No</th>

                                    <th v-for="day in Number(attendanceData.trainingResponse.noofdays)" :key="'day-' + day">
                                        Day-{{ day }}
                                    </th>
                                </tr>
                                <tr v-for="(user, index) in attendanceData.trainerResponse" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        {{
                                           user.trainer.gender === 'male' ? 'Mr.' :
                                           user.trainer.gender === 'female' ? 'Ms.' :
                                           user.trainer.gender === 'rather not say' ? 'Mx' :
                                           ''
                                         }}
                                        {{ user.trainer.name || ' '}}</td>
                                    <td>{{ user.trainer?.trainer_user_id?.departments?.title || ' '}}</td>
                                    <td>{{getDesignationTitle(user.trainer.designation)}}</td>
                                    <td>{{user.trainer.mobile || ' '}}</td>

                                    <td v-for="day in Number(attendanceData.trainingResponse.noofdays)" :key="'user-day-' + index + '-' + day"></td>
                                </tr>
                                <tr v-for="emptyIndex in 2" :key="'empty-' + emptyIndex">
                                    <td>
                                        {{ attendanceData.trainerResponse.length + emptyIndex }}
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-for="day in Number(attendanceData.trainingResponse.noofdays)" :key="'user-day-' + index + '-' + day"></td>
                                </tr>
                            </table>
                            <br />
                            <table>
                                <tr>
                                    <th colspan="5" class="list_name">Supporting Staff</th>
                                    <th :colspan="attendanceData.trainingResponse.noofdays">
                                        Signature
                                    </th>
                                </tr>
                                <tr>
                                    <th>S#</th>
                                    <th>Name</th>
                                    <th>Organization</th>
                                    <th>Designation</th>
                                    <th>Mobile No</th>
                                    <th v-for="day in Number(attendanceData.trainingResponse.noofdays)" :key="'day-' + day">
                                        Day-{{ day }}
                                    </th>
                                </tr>

                                <tr v-for="emptyIndex in 3" :key="'empty-' + emptyIndex">
                                    <td>
                                        {{ emptyIndex }}
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td v-for="day in Number(attendanceData.trainingResponse.noofdays)" :key="'empty-day-' + emptyIndex + '-' + day"></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </template>
            </div>
            <div class="container-fluid">
                <div class="row justify-content-md-center">
                    <div class="col-11">
                        <div class="row">
                            <!-- Left: Table -->
                            <div class="col-md-8 mb-4">
                                <b-card title="Marked Attendance Sheet Download Area" class="h-100" v-if="attendanceSheetUrl">
                                    <div class="table-responsive">
                                        <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>File</th>
                                                    <th>File Name</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <img :src="getFileIcon(this.attendanceSheetUrl)" alt="File Icon" width="50" height="50" style="object-fit: cover; border-radius: 5px;" />
                                                    </td>
                                                    <td>{{ getFileName(this.attendanceSheetUrl) }}</td>
                                                    <td class="text-center download-cell" @click="downloadFile()">
                                                        <button class="download-btn">
                                                            <i class="material-icons">cloud_download</i>
                                                            <span class="download-text">Download</span>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-card>
                                <!-- Show if no file uploaded -->
                                  <b-card class="h-100 text-center d-flex flex-column justify-content-center" v-else>
                                    <div>
                                      <i class="material-icons" style="font-size:50px; color:#f54c4c;">insert_drive_file</i>
                                      <p style="margin-top:10px; font-size:17px; font-weight:600; color:#f54c4c;">
                                        Marked Attendance sheet not uploaded yet
                                      </p>
                                    </div>
                                  </b-card>
                            </div>

                            <!-- Right: Upload Form -->
                            <div class="col-md-4 mb-4">
                                <b-card title="Upload Marked Attendance Sheet" class="h-100">
                                    <form @submit.prevent="uploadAttendanceSheet" enctype="multipart/form-data">
                                        <div class="form-group">
                                            <label><strong>Select File (PDF or Image)</strong></label>
                                            <b-form-file v-model="attendanceFile" accept="application/pdf,image/*" required :disabled="isUploading"></b-form-file>
                                        </div>
                                        <div class="text-right">
                                            <div class="text-right mt-4">
                                                <b-button type="submit" variant="primary" class="upload-btn" :disabled="!attendanceFile || isUploading">
                                                    <span v-if="isUploading">
                                                        <b-spinner small class="mr-2"></b-spinner>
                                                        Uploading...
                                                    </span>
                                                    <span v-else>
                                                        <i class="material-icons mr-2">cloud_upload</i>
                                                        Upload
                                                    </span>
                                                </b-button>
                                            </div>
                                        </div>
                                    </form>
                                </b-card>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div>

                <template>
                    <div style="max-width: 90%; margin: auto; box-shadow: 0 4px 12px rgba(0,0,0,0.2); border-radius: 10px; overflow: hidden; position: relative;">
                        <!-- Header -->
                        <div style="background-color: #06a6e0; color: white; padding: 16px 20px; font-size: 1.2em; font-weight: bold; position: relative;">
                            <div style="width: 90%;">{{ trainingData.title }}</div>
                            <button @click="copyAllLinks" title="Copy All" style="position: absolute; right: 20px; top: 12px; background: transparent; border: none; cursor: pointer; font-size: 1.2em; color: white;">
                                🗐
                            </button>

                        </div>

                        <!-- Links -->
                        <div style="padding: 16px 20px; background: #fff; display: flex; flex-direction: column; gap: 12px;">
                            <div v-for="link in socialFields" :key="link.label" style="background: #f2f2f2; padding: 12px; border-radius: 8px; overflow: auto;">
                                <div style="font-weight: bold;">
                                    {{ link.icon2 }} {{ link.label }}:
                                    <button @click="copySingle(link)" style="float: right; background: transparent; border: none; cursor: pointer; font-size: 1.1em; color: #555;">
                                        🗐
                                    </button>
                                </div>
                                <div style="padding-left: 26px;">{{ link.value }}</div>
                            </div>
                        </div>

                    </div>

                </template>
            </div>
            <div class="container-fluid mt-1">
                <!-- Image Upload Section -->

                <div class="row">
                    <h5 class="image-heading">Group Image</h5>
                </div>
                <div class="card text-center shadow mb-4 p-4">
                    <!-- Image preview -->
                    <div v-if="imageUrl" class="text-center">
                        <img :src="imageUrl" alt="Preview" class="img-fluid rounded shadow border" />
                    </div>
                    <div v-else class="text-muted">
                        <img src="../../../assets/group-photo-icon.png" class="img-fluid mobile-logo-img mt-2" /> <!-- Group photo icon -->
                        <div>No Image Uploaded</div>
                    </div>

                </div>

            </div>
        </div>
    </div>

    <!-- Nomination Letter Modal -->
    <div class="modal2" v-if="showNominationModal">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Nomination Letters</h4>
                    <button type="button" class="close" @click="closeNominationModal">
                        &times;
                    </button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <!-- Files List -->
                    <div v-if="nominationFiles && nominationFiles.length > 0">
                        <h6 style="font-weight: 700; margin-bottom: 15px;">Available Files:</h6>
                        <div class="uploaded-files-list">
                            <div v-for="(file, index) in nominationFiles" :key="index" class="file-item d-flex align-items-center justify-content-between mb-2 p-2" style="border: 1px solid #ddd; border-radius: 5px; background-color: #f9f9f9;">
                                <div class="file-info d-flex align-items-center" style="flex: 1;">
                                    <i class="material-icons mr-2" style="font-size: 20px; color: #007bff;">description</i>
                                    <span style="font-size: 14px; color: #333; word-break: break-all;">
                                        {{ file.split('/').pop() }}
                                    </span>
                                </div>
                                <button type="button" @click="downloadNomination(file)" class="btn btn-success btn-sm ml-2" style="min-width: 90px;">
                                    <i class="material-icons" style="font-size: 16px; vertical-align: middle;">file_download</i>
                                    Download
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <p class="text-center text-muted">No nomination letters available.</p>
                    </div>
                </div>

                <!-- Modal Footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeNominationModal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Nomination Letter Modal close -->

</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import {
    formatDateRange
} from "../../../utils/DateFormate";

import {
    downloadTrainingReport,
} from '../../../utils/DownloadReport';
import {
    downloadReference
} from '../../../utils/ReferenceReport';
import html2pdf from "html2pdf.js";

export default {
    name: "SocialCards",
    data: () => ({
        isSidebar: false,
        trainingCode: "",
        training_status: "",
        trainingData: [],
        basepath: process.env.VUE_APP_BASE_PATH,
        attendanceData: [],
        designationArr: [],
        trainingType: '',
        trainingId: '',
        Logo: require('@/assets/unodc_logo.png'),
        socialFields: [{
                label: 'X (Twitter)',
                icon: 'fa-brands fa-x-twitter',
                value: '',
                icon2: "🐤"
            },
            {
                label: 'Facebook',
                icon: 'fa-brands fa-facebook-f',
                value: '',
                icon2: "🟦"
            },
            {
                label: 'LinkedIn',
                icon: 'fa-brands fa-linkedin-in',
                value: '',
                icon2: "💼"
            },
            {
                label: 'Instagram',
                icon: 'fa-brands fa-instagram',
                value: '',
                icon2: "📷"
            },

            {
                label: 'Web Story',
                icon: 'fa-solid fa-globe',
                value: '',
                icon2: "🌐"
            }
        ],
        file: null,
        imageUrl: null,
        attendanceFile: null,
        attendanceSheetUrl: '',
        BASEPATHDYNAMIC: '',
        nominationLetter: null,
        nominationFiles: [],
        showNominationModal: false,
        isUploading: false,

    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.BASEPATHDYNAMIC = process.env.VUE_APP_BASE_PATH;
        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios.get(process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.trainingType = response.data?.training?.typetraining_id,
                this.trainingData = response.data?.training,
                this.trainingId = response.data?.training?.id;
                this.nominationLetter = response.data?.training?.training_nomination;
                
                // Parse nomination files from comma-separated string
                try {
                    const nominationData = response.data?.training?.training_nomination;
                    if (nominationData && nominationData.trim() !== '') {
                        // Split by comma and trim each URL
                        this.nominationFiles = nominationData.split(',').map(url => url.trim()).filter(url => url);
                    } else {
                        this.nominationFiles = [];
                    }
                } catch (e) {
                    console.error('Error parsing nomination files:', e);
                    this.nominationFiles = [];
                }
                
                this.attendanceSheetUrl = response.data?.training?.attendance_sheet;
                this.socialFields[0].value = response.data?.training?.twitter_link;
                this.socialFields[1].value = response.data?.training?.facebook_link;
                this.socialFields[2].value = response.data?.training?.linkedin_link;
                this.socialFields[3].value = response.data?.training?.insta_link;
                this.socialFields[4].value = response.data?.training?.web_link;
                this.imageUrl = response.data?.training?.training_image ? process.env.VUE_APP_BASE_PATH + "/" + response.data?.training?.training_image : null;
                this.training_status = response.data.training;
                if (response.data.training.trainingstatus == "In Queue") {
                    this.$router.push({
                        path: '/dashboard/programOfficer/training-information',
                        query: {
                            trainingId: this.trainingCode
                        }
                    });
                }
                this.getAttendance();

            });
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/designations/get")
            .then((response) => {
                this.designationArr = response.data;
            });
    },
    methods: {
        formatDateRange,
        downloadFile() {
            this.openLoading();
            const fullFilePath = this.BASEPATHDYNAMIC.replace(/\/$/, "") + "/" + this.attendanceSheetUrl.replace(/^\//, "");

            axios({
                    url: fullFilePath,
                    method: "GET",
                    responseType: "blob",
                    headers: {
                        Authorization: localStorage.getItem("token") // if required
                    }
                })
                .then(response => {
                    const blob = new Blob([response.data], {
                        type: response.headers["content-type"] || "application/octet-stream"
                    });

                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.setAttribute("download", this.getFileName(fullFilePath)); // Fixed here
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.closeLoading();
                })
                .catch(() => {
                    this.$toasted.global.errorMsg("Failed to download the file.");
                    this.closeLoading();
                });
        },

        openNominationModal() {
            this.showNominationModal = true;
        },
        closeNominationModal() {
            this.showNominationModal = false;
        },
        downloadNomination(fileUrl) {
            this.openLoading();
            const fullFilePath = this.BASEPATHDYNAMIC.replace(/\/$/, "") + "/" + fileUrl.replace(/^\//, "");

            axios({
                    url: fullFilePath,
                    method: "GET",
                    responseType: "blob",
                    headers: {
                        Authorization: localStorage.getItem("token") // if required
                    }
                })
                .then(response => {
                    const blob = new Blob([response.data], {
                        type: response.headers["content-type"] || "application/octet-stream"
                    });

                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.setAttribute("download", this.getFileName(fullFilePath));
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.closeLoading();
                })
                .catch(() => {
                    this.$toasted.global.errorMsg("Failed to download the file.");
                    this.closeLoading();
                });
        },

        getFileName(path) {
            return path.split("/").pop();
        },
        getFileIcon(fileName) {
            if (!fileName) {
                return "https://via.placeholder.com/50"; // Placeholder if no file
            }

            const ext = fileName.split('.').pop().toLowerCase();

            switch (ext) {
                case "pdf":
                    return "https://cdn-icons-png.flaticon.com/512/337/337946.png"; // PDF icon
                case "doc":
                case "docx":
                    return "https://cdn-icons-png.flaticon.com/512/732/732220.png"; // Word icon
                case "ppt":
                case "pptx":
                    return "https://cdn-icons-png.flaticon.com/512/888/888880.png"; // PPT icon
                case "xls":
                case "xlsx":
                    return "https://cdn-icons-png.flaticon.com/512/732/732227.png"; // Excel icon
                case "jpg":
                case "jpeg":
                case "png":
                case "gif":
                    return this.BASEPATHDYNAMIC + "/" + fileName; // Show actual image
                default:
                    return "https://cdn-icons-png.flaticon.com/512/1250/1250595.png"; // Default file icon
            }
        },
        uploadAttendanceSheet() {
            this.isUploading = true;
            const formData = new FormData();
            formData.append("attendance_sheet", this.attendanceFile); // remove `:` from key

            axios
                .put(
                    process.env.VUE_APP_BASE_PATH +
                    "/training/upload-attendance-sheet/" +
                    this.trainingId,
                    formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: localStorage.getItem("token"),
                        },
                    }
                )
                .then((response) => {
                    this.attendanceSheetUrl = response.data.attendance_sheet_url; // adjust based on actual API response
                    this.$bvToast.toast("Attendance sheet uploaded successfully!", {
                        title: "Success",
                        variant: "success",
                        solid: true,
                    });
                    axios
                        .get(
                            process.env.VUE_APP_BASE_PATH +
                            "/programOfficer/trainingsingle/get/" +
                            this.trainingCode
                        )
                        .then((response) => {

                            this.attendanceSheetUrl = response.data?.training?.attendance_sheet || '';
                            this.isUploading = false;
                        })
                        .catch(() => {
                            this.isUploading = false;
                        });
                })
                .catch((error) => {
                    console.error(error);
                    this.$bvToast.toast("Upload failed", {
                        title: "Error",
                        variant: "danger",
                        solid: true,
                    });
                    this.isUploading = false;
                });
        },
        isPdf(fileUrl) {
            return fileUrl.toLowerCase().endsWith(".pdf");
        },
        copySingle(link) {
            if (!link.value || link.value.trim() === '') {
                this.toastError(`${link.label} link is empty!`);
                return;
            }
            const formattedText = `*Event: ${this.trainingData.title}*\n${link.icon2} *${link.label}:*\n${link.value}`;
            navigator.clipboard.writeText(formattedText).then(() => {
                this.toastSuccess(`${link.label} link copied!`);
            });
        },
        copyAllLinks() {
            const nonEmptyLinks = this.socialFields.filter(link => link.value && link.value.trim() !== '');
            
            if (nonEmptyLinks.length === 0) {
                this.toastError('No links available to copy!');
                return;
            }
            
            let formattedText = `*Event: ${this.trainingData.title}*\n\n`;
            formattedText += nonEmptyLinks.map(link =>
                `${link.icon2} *${link.label}:*\n${link.value}`
            ).join('\n\n');

            navigator.clipboard.writeText(formattedText).then(() => {
                this.toastSuccess('All links copied!');
            });
        },
        formattedDate(tdate) {
            const [year, month, day] = tdate.split("-");
            const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const monthIndex = parseInt(month) - 1;
            return `${day}-${monthNames[monthIndex]}-${year}`;
        },

        // onclick show wizard steps
        trainingInformation() {
            this.$router.push({
                path: '/dashboard/programOfficer/training-information',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainerRegistration() {
            this.$router.push({
                path: '/dashboard/programOfficer/trainer-registration',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainingAgenda() {
            this.$router.push({
                path: '/dashboard/programOfficer/training-agenda',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainingMaterial() {
            this.$router.push({
                path: '/dashboard/programOfficer/wizardUploadMaterial',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainingAssessment() {

            this.$router.push({
                path: '/dashboard/programOfficer/training-assesment',
                query: {
                    trainingId: this.trainingCode
                }
            });

        },
        traineeReg() {
            this.$router.push({
                path: '/dashboard/programOfficer/trainee-registration',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        assessmentReviewFunction() {
            this.$router.push({
                path: '/dashboard/programOfficer/assesment-review',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        getReport() {
            downloadTrainingReport([this.trainingId])
        },
        downloadReferences() {
            this.openLoading();
            axios.get(process.env.VUE_APP_BASE_PATH + "/references/download/" + this.trainingId)
                .then(response => {
                    this.closeLoading();
                    if (response.data.length > 0) {
                        downloadReference(response.data);
                    } else {
                        this.$toasted.global.errorMsg('No references found for this training');
                    }
                })
                .catch(() => {
                    this.closeLoading();
                    this.$toasted.global.errorMsg('No references found for this training');
                });
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        getAttendance() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH + "/training/get-attendance/" + this.training_status.id
                )
                .then((response) => {
                    this.closeLoading();
                    this.attendanceData = response.data;

                });
        },
        getDesignationTitle(designationId) {
            const match = this.designationArr?.find(
                (item) => item.id == designationId
            );
            return match ? match.title : '';
        },
        downloadSheet() {
            this.openLoading(); // Show loading indicator

            // First load the attendance data
            axios.get(process.env.VUE_APP_BASE_PATH + "/training/get-attendance/" + this.trainingId)
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                        return;
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                        return;
                    }

                    this.attendanceData = response.data;

                    // Now generate the PDF
                    const element = document.getElementById("attendance-sheet");
                    if (!element) {
                        this.$toasted.global.errorMsg('Attendance sheet element not found');
                        this.closeLoading();
                        return;
                    }

                    // Show the hidden element
                    element.style.display = 'block';

                    // Wait for DOM to update and data to be rendered
                    this.$nextTick(() => {
                        const opt = {
                            margin: 0.5,
                            filename: `${this.trainingData.title} attendance-sheet.pdf`,
                            image: {
                                type: 'jpeg',
                                quality: 1.0
                            },
                            html2canvas: {
                                scale: 4,
                                useCORS: true,
                                logging: true,
                                letterRendering: true,
                                allowTaint: true,
                                dpi: 300,
                                windowWidth: 1920
                            },
                            jsPDF: {
                                unit: 'in',
                                format: 'a4',
                                orientation: 'landscape',
                                compress: true
                            }
                        };

                        // Add a small delay to ensure all content is rendered
                        setTimeout(() => {
                            html2pdf()
                                .set(opt)
                                .from(element)
                                .save()
                                .then(() => {
                                    // Hide the element again after PDF generation
                                    element.style.display = 'none';
                                    this.closeLoading();
                                })
                                .catch(() => {

                                    this.$toasted.global.errorMsg('Error generating PDF');
                                    this.closeLoading();
                                });
                        }, 500);
                    });
                })
                .catch(() => {

                    this.$toasted.global.errorMsg('Error loading attendance data');
                    this.closeLoading();
                });
        },
        printSheet: function () {
            const printContents = document.getElementById("attendance-sheet").innerHTML;
            const printWindow = window.open("", "_blank");

            printWindow.document.open();
            printWindow.document.write(`
                     <html>
                        <head>
                          <title>${this.trainingData.title} attendance-sheet.pdf</title>

<style>
/* General styling */
body {
    font-family: Arial, sans-serif;
}

/* Table styling */
table {
    width: 100%;
    border-collapse: collapse;
}

td,
tr {
    border: 1px solid black;
    padding: 8px;
    text-align: left;
}

th {
    border: 1px solid black;
    padding: 8px;
    text-align: center;
    background-color: #f2f2f2;
}

/* Header section styling */
.header {
    justify-content: space-between;
    align-items: center;
}

h3 {
    text-align: center;
    text-decoration: underline;
}

.header img {
    width: 200px;
    /* Adjust the size of the image */
}

/* Address section */
.address {
    font-size: 14px;
    margin-top: 0px;
    text-align: left;
}

/* List name styling */
.list_name {
    font-size: 18px;
}
</style>
                              </head>
                          <body onload="window.print()">
                                ${printContents}
                          </body>
                      </html>

    `);
            printWindow.document.close();

        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },

    },
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar
    }
};
</script>

<style scoped>
.vs-breadcrumb {
  font-size: 18px !important;
  font-weight: 600 !important;
}
.btn-primary {
  font-size: 14px;
  height: 44px;
  background: #06a6e0;
  color: #ffffff;
  font-weight: 500;
  border-radius: 5px
}
.white-text {
  color: #ffffff;
}
.btn-primary:hover {
  background: #08769e;
}
.btn-secondary{
  height: 44px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 5px
}
.btn-info{
   height: 50px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 5px
}
#progressbar .completed {
  color: #06a6e0 !important;
}

#progressbar li.completed:before,
#progressbar li.completed:after {
  background: #06a6e0 !important;
}

#grad1 {
  background-color: #fff;
}

#msform {
  text-align: center;
  position: relative;
  margin-top: 20px;
}

#msform fieldset .form-card {
  background: white;
  border: 0 none;
  border-radius: 0px;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
  padding: 20px 40px 30px 40px;
  box-sizing: border-box;
  width: 94%;
  margin: 0 3% 20px 3%;
  position: relative;
}

#msform fieldset {
  padding: 10px;
  background: #f7f7f7 !important;
  border: 0 none;
  border-radius: 2rem;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  border: 2px solid #ccc;
  padding-bottom: 20px;
  position: relative;
}

#msform fieldset:not(:first-of-type) {
  display: none;
}

#msform fieldset .form-card {
  text-align: left;
  color: #9e9e9e;
}

#msform .action-button {
  width: 100px;
  background: skyblue;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
  width: 100px;
  background: #616161;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
  border: none;
  outline: 0;
  border-bottom: 1px solid #ccc;
  padding: 2px 5px 3px 5px;
  margin: 2px;
}

select.list-dt:focus {
  border-bottom: 2px solid skyblue;
}

.card {
  z-index: 0;
  border: none;
  border-radius: 0.5rem;
  position: relative;
}

.fs-title {
  font-size: 25px;
  color: #2c3e50;
  margin-bottom: 10px;
  font-weight: bold;
  text-align: left;
}

#progressbar {
  margin-bottom: 30px;
  overflow: hidden;
  color: lightgrey;
}

#progressbar .active {
  color: #000000;
}

#progressbar li {
  list-style-type: none;
  font-size: 12px;
  width: 9.5%;
  text-align:center;
  float: left;
  position: relative;
}

#progressbar #NewTraining:before {
  content: "1";
}

#progressbar #PoAssignment:before {
  content: "2";
}

#progressbar #TrainingInformation:before {
  content: "3";
}

#progressbar #TrainingAgenda:before {
  content: "4b";
}
#progressbar #Trainingmaterial:before {
  content: "4c";
}

#progressbar #TrainingAssessments:before {
  content: "4d";
}

#progressbar #TrainerRegistration:before {
  content: "4a";
}

#progressbar #TraineeRegistration:before {
  content: "4e";
}

#progressbar #AssessmentReview:before {
  content: "5";
}

#progressbar #Completion:before {
  content: "6";
}
#progressbar li:before {
  width: 35px;
  height: 35px;
  line-height: 30px;
  display: block;
  font-size: 18px;
  color: #ffffff;
  background: lightgray;
  border-radius: 50%;
  margin: 0 auto 10px auto;
  padding: 2px;
}

#progressbar li:after {
  content: "";
  width: 100%;
  height: 2px;
  background: lightgray;
  position: absolute;
  left: 0;
  top: 17px;
  z-index: -1;
}

#progressbar li.active:before,
#progressbar li.active:after {
  background: #000000;
}

.radio-group {
  position: relative;
  margin-bottom: 25px;
}

.radio {
  display: inline-block;
  width: 204;
  height: 104;
  border-radius: 0;
  background: lightblue;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  cursor: pointer;
  margin: 8px 2px;
}

.radio:hover {
  box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
  width: 100%;
  object-fit: cover;
}

/*Sheet style */
  table {
            width: 100%;
            border-collapse: collapse;
        }
        th, td, tr {
            border: 1px solid black;
            padding: 8px;
            text-align: center;
        }
        th {
            background-color: #f2f2f2;
        }
        .header {
            /* display: flex; */
            justify-content: space-between;
            align-items: center;

        }

        h3 {
            text-align: center;
            text-decoration: underline;
        }
        .address {
            font-size: 14px;
            margin-top: 0px;
            text-align: left;
        }
        .list_name{
          font-size: 18px
        }

       #attendance-sheet {
  display: none;
}

/* Only show the attendance sheet when printing */
@media print {
      #attendance-sheet {
        display: block;
        position: relative;
        width: 100%;
        page-break-before: always; /* Ensure the sheet starts on a new page */
      }

      /* Hide everything else during printing */
      body * {
        visibility: hidden;
      }

      #attendance-sheet, #attendance-sheet * {
        visibility: visible;
      }

      #attendance-sheet {
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    #attendance-sheet {
      display: none;
    }

    #attendance-sheet table {
      width: 100%;
      border-collapse: collapse;
    }

    #attendance-sheet th {
      border: 1px solid black;
      padding: 8px;
      text-align: center;
      background-color: #f2f2f2;
    }

    #attendance-sheet td {
      border: 1px solid black;
      padding: 8px;
      text-align: left;
    }

    /* Specific column alignments */
    #attendance-sheet td:first-child, /* Serial number column */
    #attendance-sheet td:nth-child(5) { /* Contact number column */
      text-align: center;
    }

    #attendance-sheet td:nth-child(2), /* Name column */
    #attendance-sheet td:nth-child(3), /* Organization column */
    #attendance-sheet td:nth-child(4) { /* Designation column */
      text-align: left;
    }

    /* Signature columns alignment */
    #attendance-sheet td:nth-child(n+6) {
      text-align: center;
      min-width: 100px;
    }

    #attendance-sheet .header {
      justify-content: space-between;
      align-items: center;
    }

    #attendance-sheet .address {
      font-size: 14px;
      margin-top: 0px;
      text-align: left;
    }

    #attendance-sheet .list_name {
      font-size: 18px;
    }
    /* Updated table styles for better vertical display */
    #attendance-sheet table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed; /* Added to control column widths */
    }

    #attendance-sheet th, 
    #attendance-sheet td {
        border: 1px solid black;
        padding: 8px;
        word-wrap: break-word; /* Allow text to wrap within cells */
    }

    #attendance-sheet th {
        background-color: #f2f2f2;
        font-weight: bold;
    }
    /* Set specific column widths */
    #attendance-sheet td:first-child { /* Serial number column */
        width: 5%;
        text-align: center;
    }

    #attendance-sheet td:nth-child(2) { /* Name column */
        width: 20%;
    }

    #attendance-sheet td:nth-child(3) { /* Organization column */
        width: 20%;
    }

    #attendance-sheet td:nth-child(4) { /* Designation column */
        width: 20%;
    }

    #attendance-sheet td:nth-child(5) { /* Contact number column */
        width: 15%;
        text-align: center;
    }

    /* Signature columns */
    #attendance-sheet td:nth-child(n+6) {
        width: 5%;
        text-align: center;
        min-width: 50px;
    }

    /* Ensure the table fits within the page width */
    #attendance-sheet {
        max-width: 100%;
        overflow-x: auto;
    }

    /* Adjust header styles */
    #attendance-sheet .header {
        text-align: center;
        margin-bottom: 20px;
    }

    #attendance-sheet .header h3 {
        margin: 10px 0;
    }

    /* Print specific styles */
    @media print {
        #attendance-sheet {
            width: 100%;
            margin: 0;
            padding: 0;
        }

        #attendance-sheet table {
            page-break-inside: auto;
        }

        #attendance-sheet tr {
            page-break-inside: avoid;
            page-break-after: auto;
        }
    }

    /* Socila links */
.social-card {
  border-radius: 15px;
  border: 1px solid #06a6e0;
  height: 150px;
}

.social-icon {
  font-size: 36px;
  color: #06a6e0;
}
.image-heading{
  font-size: 30px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  margin-left: 20px;
  background-color: #06a6e0;
    color: white;
    padding: 5px 12px;
    border-radius: 5px;
    margin-top: 8px;
}
.form-control{
  line-height: 1;
}
.card-text{
    overflow: hidden;
}
.upload-sheet{
    height: 34px;
}

.download-btn {
  background-color: #4285f4;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.download-btn:hover {
  background-color: #3367d6;
  transform: translateY(-1px);
}

.download-btn i {
  margin-right: 6px;
  font-size: 18px;
}

.download-text {
  font-size: 0.85rem;
}

/* Modal Styles */
.modal2 {
    display: block;
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-dialog {
    position: relative;
    width: auto;
    max-width: 600px;
    margin: 1.75rem auto;
}

.modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    outline: 0;
}

.modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: calc(0.3rem - 1px);
    border-top-right-radius: calc(0.3rem - 1px);
}

.modal-title {
    margin-bottom: 0;
    line-height: 1.5;
}

.modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: 1rem;
}

.modal-footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    padding: 0.75rem;
    border-top: 1px solid #dee2e6;
    border-bottom-right-radius: calc(0.3rem - 1px);
    border-bottom-left-radius: calc(0.3rem - 1px);
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
    line-height: 1;
    background: transparent;
    border: 0;
    cursor: pointer;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

</style>
